import { render } from "./ProspectEvents.vue?vue&type=template&id=3ac77759"
import script from "./ProspectEvents.vue?vue&type=script&lang=js"
export * from "./ProspectEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__